const gnbInfo = {
    menuCd: "TPMN",
    home: "TDAY",
    disableHomePlatformType: ["StudyRoom"],
};

export default gnbInfo;
